import { ApiProperty } from '@nestjs/swagger';
export class VehicleIdRequest {
  @ApiProperty()
  vehicleId: number;
}

